var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"px-4 py-4",on:{"click":_vm.login}},[_vm._v(" Log in with "),_c('strong',[_vm._v("NOI Authentication")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }